import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { DataNotFoundPage } from '@data/pages/DataNotFoundPage/DataNotFoundPage';
import { DataIssuePage } from '@data/pages/DataIssuePage/DataIssuePage';

/**
 * Error boundary for /data routes.
 * - 404 responses (invalid route, unknown product, etc.) → DataNotFoundPage
 * - Any other error (network failure, API 500, etc.) → DataIssuePage
 */
export function DataErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <DataNotFoundPage />;
  }

  return <DataIssuePage />;
}
